import { ViewFactory } from 'src/3rds/cube-react'

import { GrupoManualScope } from '../GrupoManual.scopes'
import GrupoManualView from './GrupoManual.view'

export { GrupoManualView } from './GrupoManual.view'

export function registerViews(rv = ViewFactory.register) {
    rv(GrupoManualScope, GrupoManualView)
}
